import React, { Fragment, useState, useEffect } from 'react';
import { useSelector} from 'react-redux'
import EditableInput from './EditableInput';
import local from './local/get_localisation'

export default function GetUserDevices(props){

    const setup = useSelector(state => state.site.setup);
    const [AllIs, setAllIs] = useState({done:false, error:null, readylst:false, readyTypes:false});
    const [dev, setDevices] = useState([]);
    
    if(localStorage.user){
        var user = JSON.parse(localStorage.getItem("user"));
    } else {
        window.location.href = '/'+setup.lang+'/login';
    }

    let LANG = setup.lang;

        let langStr = {
        ru:'ru-RU',
        en:'en-GB',
        de:'de-DE'
        }

useEffect(() => { 
    GetUserDevices(); 
}, [props.counter] );
    

    
if(AllIs.error){
return (
    <Fragment>
        <div className="login">ASK QST: {AllIs.error.message}</div>
    </Fragment>
)
} 


function GetDate(sec){
    let date_s = new Date(sec * 1000);
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return(
        date_s.toLocaleString(langStr[LANG], options)
    )
}


return(
<Fragment>
    {
    AllIs.done?
        <Fragment>
            {
            dev.qwn>0?
                <Fragment>
                    <br/><span className='wht'>{local[LANG].reged+dev.qwn+' '+local[LANG].pcs}</span>
                    {
                        dev.qwn == 1? 
                        <Fragment>
                            <p>
                                <span className='ttlpfx'>{dev.dev.pfx}</span>
                                <h2 className='red'>{dev.dev.t}</h2>
                                <span>SN:<EditableInput tag='sn' content={dev.dev.sn} tid={dev.dev.id} inline/></span><br/>
                                <span>{local[LANG].data}: {GetDate(dev.dev.d)}</span><br/>
                                <span>{local[LANG].warranty}: {GetDate(dev.dev.exp)}</span>
                            </p>
                        </Fragment> 
                        : 
                        <Fragment>
                        { dev.dev.map((i, key) => 
                            <p key={key}>
                                <span className='ttlpfx'>{i.pfx}</span>
                                <h2 className='red'>{i.t}</h2>
                                <span>SN:<EditableInput tag='sn' content={i.sn} tid={i.id} inline/></span><br/>
                                <span>{local[LANG].data}: {GetDate(i.d)}</span>
                                <br/><span>{local[LANG].warranty}: {GetDate(i.exp)}</span>
                            </p>
                            )}
                        </Fragment>
                    }
                </Fragment>
            :
            <span className='wht'>{local[LANG].msg}</span>
            }
        </Fragment> :null
    }
</Fragment>
)   

 function GetUserDevices(){
    const form = new FormData()
          form.append('lang', setup.lang);
          form.append('user', user.usr);

    const MyInit = { 
                method: 'POST',
                body: form
                };
  fetch(setup.domen+setup.folder+'loadevs', MyInit)
    .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.text()+'Something went wrong ...');
        }
    })
    .then(data => {
        AllIs.done = true;
        setDevices(data);
    })
    .catch(error => {
        //setAllIs({...AllIs, error:error});
    });
  }

} 